import { Voter } from "@activecollab/security";
import { isClient, isOwner } from "~/utils/userHelper";

export class CalendarVoter extends Voter {
  attributes = ["delete", "restore", "edit", "export", "refresh"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && (subject.class === "UserCalendar" || subject.class === "ExternalCalendar");
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "delete":
      case "edit": {
        if (isClient(user)) {
          return false;
        }
        if (isOwner(user)) {
          return true;
        }
        if (subject.created_by_id === user.id) {
          return true;
        }
        return false;
      }
      case "restore": {
        if (user.class === "Owner") {
          return true;
        }
        if (user.id === subject.trashed_by_id) {
          return true;
        }
        return false;
      }
      case "export": {
        if (subject.class === "UserCalendar") {
          return true;
        }
        return false;
      }
      case "refresh": {
        if (isClient(user)) {
          return false;
        }
        if (subject.class === "ExternalCalendar") {
          if (isOwner(user)) {
            return true;
          }
          if (subject.created_by_id === user.id) {
            return true;
          }
        }
        return false;
      }
    }

    throw new Error("This code should not be reached!");
  }

  getCalendar = (subject) => {
    if (subject.calendar_id && this.state.calendars) {
      return this.state.calendars[subject.calendar_id];
    }
  };
}
